import { FC } from "react"

import CustomButtonRight from "../customButtonRight";
import CustomColumnChart from "../customColumnChart";

import { StatisticsObjectType } from "./types";



const CaseVolumeColumnChart: FC<StatisticsObjectType> = ({ StatisticsObjectType, buttonShows }): JSX.Element => {
  return (
    <div className="row mt-2">
      <div className={`${buttonShows ? " col-12 col-sm-12 col-md-9" : "col"}`} style={{ maxHeight: 550 }}>
        <CustomColumnChart
          title="Case Volume"
          LineChartObject={StatisticsObjectType.case_volume.filter((item) => item.name !== "PA Required")}
        />
      </div>
      {buttonShows &&
        <div className="col-12 col-sm-12 col-md-3 mt-4 mt-sm-4 mt-md-0 d-flex flex-column flex-fill" style={{ maxHeight: 550 }}>
          <CustomButtonRight StatisticsObjectType={StatisticsObjectType} />
        </div>
      }
    </div>
  )
}

export default CaseVolumeColumnChart;
